import Render from '@Views/components/layout/context.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class Context extends Vue {}
